import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useAuthContext } from "../hooks/useAuthContext";
import "./Sidebar.css";
import WhiteLogo from "../assets/logoblanco.png";
import { getToken, onMessage } from "firebase/messaging";
import { projectFirestore, projectMessaging } from "../firebase/config";
import { Toast, ToastContainer } from "react-bootstrap";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";

export default function Sidebar({ ruta }) {
  const { user, register, employee } = useAuthContext();
  const sidebarCollapsed = localStorage.getItem("sidebar-collapsed");
  const [isExpanded, setIsExpanded] = useState(
    sidebarCollapsed ? false : false,
  );
  const [toastes, setToastes] = useState([]);

  const handleToggler = () => {
    if (isExpanded) {
      setIsExpanded(false);
      document.body.classList.remove("sidebar-expanded");
      localStorage.setItem("sidebar-collapsed", true);
    } else {
      setIsExpanded(true);
      document.body.classList.add("sidebar-expanded");
      localStorage.removeItem("sidebar-collapsed");
    }
  };

  useEffect(() => {
    function requestPermission() {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          getToken(projectMessaging, {
            vapidKey:
              "BOyZ_ai29exC_Ezy6yDQoGIcEZrhAgsy7iRAPs2i_1ri24fbdL2eOG9nvmMLibzTwdYs_JNs0RLtLyZqFRQLkMs",
          })
            .then(async (currentToken) => {
              if (currentToken) {
                const refdocus = doc(projectFirestore, "users", user.uid);
                const docus = await getDoc(refdocus);
                if (docus.exists()) {
                  updateDoc(refdocus, {
                    fcmToken: currentToken,
                  });
                  onMessage(projectMessaging, (payload) => {
                    const notificationTitle = payload.data.title;
                    toastes.push({
                      title: notificationTitle,
                      body: payload.data.body,
                      visible: true,
                    });
                    setToastes([...toastes]);
                    console.log("Message received. ", payload);
                  });
                } else {
                  let userdocn = {
                    email: user.email,
                    fullName: user.displayName ? user.displayName : "",
                    id: user.uid,
                    fcmToken: currentToken,
                  };
                  setDoc(refdocus, userdocn);
                  onMessage(projectMessaging, (payload) => {
                    const notificationTitle = payload.data.title;
                    toastes.push({
                      title: notificationTitle,
                      body: payload.data.body,
                      visible: true,
                    });
                    setToastes([...toastes]);
                    console.log("Message received. ", payload);
                  });
                }
              } else {
                console.log(
                  "No registration token available. Request permission to generate one.",
                );
                // ...
              }
            })
            .catch((err) => {
              console.log("An error occurred while retrieving token. ", err);
              // ...
            });
          console.log("Notification permission granted.");
        } else {
          console.log("Unable to get permission to notify.");
        }
      });
    }
    requestPermission();
  }, [toastes, user.displayName, user.email, user.uid]);

  if (!user) return null;

  return (
    <>
      <ToastContainer
        className="position-fixed top-10 end-0 p-3"
        style={{ zIndex: 9999 }}
      >
        {toastes.map((toast, index) => (
          <Toast
            key={index}
            onClose={() => {
              toast.visible = false;
              setToastes([...toastes]);
            }}
            show={toast.visible}
            delay={15000}
            autohide
          >
            <Toast.Header>
              <img src="/favicon.ico" className="rounded me-2" alt="" />
              <strong className="me-auto">{toast.title}</strong>
              {/* <small className="text-muted">just now</small> */}
            </Toast.Header>
            <Toast.Body>{toast.body}</Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
      <nav className={isExpanded ? "sidebar" : "sidebar close"}>
        <header>
          {isExpanded && (
            <div className="image-text">
              <span
                className={`image ${isExpanded ? "expanded" : "collapsed"}`}
              >
                <img
                  src={WhiteLogo}
                  alt=""
                  style={{ width: isExpanded ? "100px" : "100px" }}
                />
              </span>
              <div className="text logo-text">
                <span className="name" style={{ fontSize: "18px" }}></span>
              </div>
            </div>
          )}
          <i onClick={handleToggler} className="bx bx-chevron-right toggle"></i>
        </header>
        <div className="menu-bar">
          <div className="menu">
            {register && register.type === "truck-admin" ? (
              <>
                <span
                  style={{
                    fontSize: "18px",
                    fontWeight: "bolder",
                    color: "white",
                  }}
                >
                  {" "}
                  Truck Admin
                </span>
                <ul className="menu-links">
                  <li
                    className={
                      ruta === "/config-admin-trucks"
                        ? "nav-link activateLink"
                        : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/config-admin-trucks">
                      <i className="bx bx-cog icon"></i>
                      <span
                        className={
                          ruta === "/config-admin-trucks"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        CONFIGURACION
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/generador-qr-admin"
                        ? "nav-link activateLink"
                        : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/generador-qr-admin">
                      <i className="bx bx-qr icon"></i>
                      <span
                        className={
                          ruta === "/generador-qr-admin"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        GENERADOR QR
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/mesas" ? "nav-link activateLink" : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/mesas">
                      <i className="bx bxs-shapes icon"></i>
                      <span
                        className={
                          ruta === "/mesas"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        MESAS
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/puestos-admin"
                        ? "nav-link activateLink"
                        : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/puestos-admin">
                      <i className="bx bxs-store icon"></i>
                      <span
                        className={
                          ruta === "/puestos-admin"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        PUESTOS
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/calificaciones"
                        ? "nav-link activateLink"
                        : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/calificaciones">
                      <i className="bx bx-star icon"></i>
                      <span
                        className={
                          ruta === "/calificaciones"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        RESEÑAS
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </>
            ) : (
              <></>
            )}
            {register &&
            register.type === "restaurant" &&
            employee === undefined ? (
              <>
                <span
                  style={{
                    fontSize: "18px",
                    fontWeight: "bolder",
                    color: "white",
                  }}
                >
                  {" "}
                  Restaurant
                </span>
                <ul className="menu-links">
                  <li
                    className={
                      ruta === "/config" ? "nav-link activateLink" : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/config">
                      <i className="bx bx-cog icon"></i>
                      <span
                        className={
                          ruta === "/config"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        CONFIGURACION
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/checador" ? "nav-link activateLink" : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/checador">
                      <i className="bx bx-qr icon"></i>
                      <span
                        className={
                          ruta === "/checador"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        CHECADOR
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/menu" ? "nav-link activateLink" : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/menu">
                      <i className="bx bx-food-menu icon"></i>
                      <span
                        className={
                          ruta === "/menu"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        MENU
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/inventario"
                        ? "nav-link activateLink"
                        : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/inventario">
                      <i className="bx bx-book-bookmark icon"></i>
                      <span
                        className={
                          ruta === "/inventario"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        INVENTARIO
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/cocina" ? "nav-link activateLink" : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/cocina">
                      <i className="bx bx-restaurant icon"></i>
                      <span
                        className={
                          ruta === "/cocina"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        COCINA
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/turnero" ? "nav-link activateLink" : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/turnero">
                      <i className="bx bx-restaurant icon"></i>
                      <span
                        className={
                          ruta === "/turnero"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        TURNERO
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/historialCajas"
                        ? "nav-link activateLink"
                        : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/historialCajas">
                      <i className="bx bx-dish icon"></i>
                      <span
                        className={
                          ruta === "/historialCajas"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        HISTORIAL CAJAS
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/personal" ? "nav-link activateLink" : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/personal">
                      <i className="bx bxs-user icon"></i>
                      <span
                        className={
                          ruta === "/personal"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        PERSONAL
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/meseros" ? "nav-link activateLink" : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/meseros">
                      <i className="bx bxs-user icon"></i>
                      <span
                        className={
                          ruta === "/meseros"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        MESEROS
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/mesas" ? "nav-link activateLink" : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/mesas">
                      <i className="bx bxs-shapes icon"></i>
                      <span
                        className={
                          ruta === "/mesas"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        MESAS
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/Promociones"
                        ? "nav-link activateLink"
                        : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/Promociones">
                      <i className="bx bxs-shapes icon"></i>
                      <span
                        className={
                          ruta === "/Promociones"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        PROMOCIONES
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/galeria" ? "nav-link activateLink" : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/galeria">
                      <i className="bx bxs-shapes icon"></i>
                      <span
                        className={
                          ruta === "/galeria"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        GALERIA
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/resenas" ? "nav-link activateLink" : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/resenas">
                      <i className="bx bx-star icon"></i>
                      <span
                        className={
                          ruta === "/resenas"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        RESEÑAS
                      </span>
                    </NavLink>
                  </li>
                  <li
                    className={
                      ruta === "/calificacionesPedidos"
                        ? "nav-link activateLink"
                        : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/calificacionesPedidos">
                      <i className="bx bx-star icon"></i>
                      <span
                        className={
                          ruta === "/calificacionesPedidos"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        CALIF. PEDIDOS
                      </span>
                    </NavLink>
                  </li>
                  <li
                    className={
                      ruta === "/reportes" ? "nav-link activateLink" : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/reportes">
                      <i className="bx bx-pie-chart-alt-2 icon"></i>
                      <span
                        className={
                          ruta === "/reportes"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        REPORTES
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </>
            ) : (
              <></>
            )}
            {register && register.type === "restaurant" && employee ? (
              <>
                <span
                  style={{
                    fontSize: "18px",
                    fontWeight: "bolder",
                    color: "white",
                  }}
                >
                  {" "}
                  Restaurant
                </span>
                <ul className="menu-links">
                  {employee.configuracion !== false &&
                  employee.configuracion !== undefined ? (
                    <li
                      className={
                        ruta === "/config" ? "nav-link activateLink" : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/config">
                        <i className="bx bx-cog icon"></i>
                        <span
                          className={
                            ruta === "/config"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          CONFIGURACION
                        </span>
                      </NavLink>
                    </li>
                  ) : (
                    <></>
                  )}

                  {employee.checador !== false &&
                  employee.checador !== undefined ? (
                    <li
                      className={
                        ruta === "/checador"
                          ? "nav-link activateLink"
                          : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/checador">
                        <i className="bx bx-qr icon"></i>
                        <span
                          className={
                            ruta === "/checador"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          CHECADOR
                        </span>
                      </NavLink>
                    </li>
                  ) : (
                    <></>
                  )}

                  {employee.menu !== false && employee.menu !== undefined ? (
                    <li
                      className={
                        ruta === "/menu" ? "nav-link activateLink" : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/menu">
                        <i className="bx bx-food-menu icon"></i>
                        <span
                          className={
                            ruta === "/menu"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          MENU
                        </span>
                      </NavLink>
                    </li>
                  ) : (
                    <></>
                  )}

                  {employee.inventario !== false &&
                  employee.inventario !== undefined ? (
                    <li
                      className={
                        ruta === "/inventario"
                          ? "nav-link activateLink"
                          : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/inventario">
                        <i className="bx bx-book-bookmark icon"></i>
                        <span
                          className={
                            ruta === "/inventario"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          INVENTARIO
                        </span>
                      </NavLink>
                    </li>
                  ) : (
                    <></>
                  )}

                  {(employee.turnero !== false &&
                    employee.turnero !== undefined) ||
                  employee.barra ? (
                    <li
                      className={
                        ruta === "/turnero"
                          ? "nav-link activateLink"
                          : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/turnero">
                        <i className="bx bx-restaurant icon"></i>
                        <span
                          className={
                            ruta === "/turnero"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          {employee && employee.barra
                            ? "BARRA/COCINA"
                            : "TURNERO"}
                        </span>
                      </NavLink>
                    </li>
                  ) : (
                    <></>
                  )}

                  {employee.personal !== false &&
                  employee.personal !== undefined ? (
                    <li
                      className={
                        ruta === "/personal"
                          ? "nav-link activateLink"
                          : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/personal">
                        <i className="bx bxs-user icon"></i>
                        <span
                          className={
                            ruta === "/personal"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          PERSONAL
                        </span>
                      </NavLink>
                    </li>
                  ) : (
                    <></>
                  )}

                  {employee.meseros !== false &&
                  employee.meseros !== undefined ? (
                    <li
                      className={
                        ruta === "/meseros"
                          ? "nav-link activateLink"
                          : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/meseros">
                        <i className="bx bxs-user icon"></i>
                        <span
                          className={
                            ruta === "/meseros"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          MESEROS
                        </span>
                      </NavLink>
                    </li>
                  ) : (
                    <></>
                  )}

                  {employee.mesas !== false && employee.mesas !== undefined ? (
                    <li
                      className={
                        ruta === "/mesas" ? "nav-link activateLink" : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/mesas">
                        <i className="bx bxs-shapes icon"></i>
                        <span
                          className={
                            ruta === "/mesas"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          MESAS
                        </span>
                      </NavLink>
                    </li>
                  ) : (
                    <></>
                  )}

                  {employee.promociones !== false &&
                  employee.promociones !== undefined ? (
                    <li
                      className={
                        ruta === "/Promociones"
                          ? "nav-link activateLink"
                          : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/Promociones">
                        <i className="bx bxs-shapes icon"></i>
                        <span
                          className={
                            ruta === "/Promociones"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          PROMOCIONES
                        </span>
                      </NavLink>
                    </li>
                  ) : (
                    <></>
                  )}

                  {employee.galeria !== false &&
                  employee.galeria !== undefined ? (
                    <li
                      className={
                        ruta === "/galeria"
                          ? "nav-link activateLink"
                          : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/galeria">
                        <i className="bx bxs-shapes icon"></i>
                        <span
                          className={
                            ruta === "/galeria"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          GALERIA
                        </span>
                      </NavLink>
                    </li>
                  ) : (
                    <></>
                  )}

                  {employee.resenas !== false &&
                  employee.resenas !== undefined ? (
                    <li
                      className={
                        ruta === "/resenas"
                          ? "nav-link activateLink"
                          : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/resenas">
                        <i className="bx bx-star icon"></i>
                        <span
                          className={
                            ruta === "/resenas"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          RESEÑAS
                        </span>
                      </NavLink>
                    </li>
                  ) : (
                    <></>
                  )}
                </ul>
              </>
            ) : (
              <></>
            )}
            {register && register.type === "truck" && employee === undefined ? (
              <>
                <span
                  style={{
                    fontSize: "18px",
                    fontWeight: "bolder",
                    color: "white",
                  }}
                >
                  Truck
                </span>
                <ul className="menu-links">
                  <li
                    className={
                      ruta === "/config" ? "nav-link activateLink" : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/config">
                      <i className="bx bx-cog icon"></i>
                      <span
                        className={
                          ruta === "/config"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        CONFIGURACIÓN
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/personal" ? "nav-link activateLink" : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/personal">
                      <i className="bx bxs-user icon"></i>
                      <span
                        className={
                          ruta === "/personal"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        PERSONAL
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/checador" ? "nav-link activateLink" : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/checador">
                      <i className="bx bx-qr icon"></i>
                      <span
                        className={
                          ruta === "/checador"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        CHECADOR
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/qr-turno-trucks"
                        ? "nav-link activateLink"
                        : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/qr-turno-trucks">
                      <i className="bx bx-qr icon"></i>
                      <span
                        className={
                          ruta === "/qr-turno-trucks"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        GENERADOR QR
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/menu" ? "nav-link activateLink" : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/menu">
                      <i className="bx bx-food-menu icon"></i>
                      <span
                        className={
                          ruta === "/menu"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        MENU
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/cocina" ? "nav-link activateLink" : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/cocina">
                      <i className="bx bx-restaurant icon"></i>
                      <span
                        className={
                          ruta === "/cocina"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        COCINA
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/turnero" ? "nav-link activateLink" : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/turnero">
                      <i className="bx bx-restaurant icon"></i>
                      <span
                        className={
                          ruta === "/turnero"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        TURNERO
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/historialCajas"
                        ? "nav-link activateLink"
                        : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/historialCajas">
                      <i className="bx bx-dish icon"></i>
                      <span
                        className={
                          ruta === "/historialCajas"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        HISTORIAL CAJAS
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/ventas-ordenes-trucks"
                        ? "nav-link activateLink"
                        : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/ventas-ordenes-trucks">
                      <i className="bx bxs-check-square icon"></i>
                      <span
                        className={
                          ruta === "/ventas-ordenes-trucks"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        VENTAS / ORDENES
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/inventario"
                        ? "nav-link activateLink"
                        : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/inventario">
                      <i className="bx bx-book-bookmark icon"></i>
                      <span
                        className={
                          ruta === "/inventario"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        INVENTARIO
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/Promociones"
                        ? "nav-link activateLink"
                        : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/Promociones">
                      <i className="bx bxs-shapes icon"></i>
                      <span
                        className={
                          ruta === "/Promociones"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        PROMOCIONES
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/calificaciones"
                        ? "nav-link activateLink"
                        : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/calificaciones">
                      <i className="bx bx-star icon"></i>
                      <span
                        className={
                          ruta === "/calificaciones"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        CALIF. DE TRUCK
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/calificacionesPedidos"
                        ? "nav-link activateLink"
                        : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/calificacionesPedidos">
                      <i className="bx bx-star icon"></i>
                      <span
                        className={
                          ruta === "/calificacionesPedidos"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        CALIF. PEDIDOS
                      </span>
                    </NavLink>
                  </li>

                  <li
                    className={
                      ruta === "/reportes" ? "nav-link activateLink" : "navlink"
                    }
                  >
                    <NavLink exact="true" to="/reportes">
                      <i className="bx bx-pie-chart-alt-2 icon"></i>
                      <span
                        className={
                          ruta === "/reportes"
                            ? "text nav-text changeColor"
                            : "text nav-text"
                        }
                        style={{ fontSize: 12 }}
                      >
                        REPORTES
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </>
            ) : (
              <></>
            )}
            {register && register.type === "truck" && employee ? (
              <>
                <span
                  style={{
                    fontSize: "18px",
                    fontWeight: "bolder",
                    color: "white",
                  }}
                >
                  Truck
                </span>
                <ul className="menu-links">
                  {employee.configuracion !== false &&
                  employee.configuracion !== undefined ? (
                    <li
                      className={
                        ruta === "/config" ? "nav-link activateLink" : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/config">
                        <i className="bx bx-cog icon"></i>
                        <span
                          className={
                            ruta === "/config"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          CONFIGURACIÓN
                        </span>
                      </NavLink>
                    </li>
                  ) : (
                    <></>
                  )}

                  {employee.personal !== false &&
                  employee.personal !== undefined ? (
                    <li
                      className={
                        ruta === "/personal"
                          ? "nav-link activateLink"
                          : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/personal">
                        <i className="bx bxs-user icon"></i>
                        <span
                          className={
                            ruta === "/personal"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          PERSONAL
                        </span>
                      </NavLink>
                    </li>
                  ) : (
                    <></>
                  )}

                  {employee.checador !== false &&
                  employee.checador !== undefined ? (
                    <li
                      className={
                        ruta === "/checador"
                          ? "nav-link activateLink"
                          : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/checador">
                        <i className="bx bx-qr icon"></i>
                        <span
                          className={
                            ruta === "/checador"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          CHECADOR
                        </span>
                      </NavLink>
                    </li>
                  ) : (
                    <></>
                  )}
                  {employee.generador && (
                    <li
                      className={
                        ruta === "/qr-turno-trucks"
                          ? "nav-link activateLink"
                          : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/qr-turno-trucks">
                        <i className="bx bx-qr icon"></i>
                        <span
                          className={
                            ruta === "/qr-turno-trucks"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          GENERADOR QR
                        </span>
                      </NavLink>
                    </li>
                  )}

                  {employee.menu !== false && employee.menu !== undefined ? (
                    <li
                      className={
                        ruta === "/menu" ? "nav-link activateLink" : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/menu">
                        <i className="bx bx-food-menu icon"></i>
                        <span
                          className={
                            ruta === "/menu"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          MENU
                        </span>
                      </NavLink>
                    </li>
                  ) : (
                    <></>
                  )}

                  {(employee.turnero !== false &&
                    employee.turnero !== undefined) ||
                  employee.barra ? (
                    <li
                      className={
                        ruta === "/turnero"
                          ? "nav-link activateLink"
                          : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/turnero">
                        <i className="bx bx-restaurant icon"></i>
                        <span
                          className={
                            ruta === "/turnero"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          {employee && employee.barra
                            ? "BARRA/COCINA"
                            : "TURNERO"}
                        </span>
                      </NavLink>
                    </li>
                  ) : (
                    <></>
                  )}
                  {employee.ventas && (
                    <li
                      className={
                        ruta === "/ventas-ordenes-trucks"
                          ? "nav-link activateLink"
                          : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/ventas-ordenes-trucks">
                        <i className="bx bxs-check-square icon"></i>
                        <span
                          className={
                            ruta === "/ventas-ordenes-trucks"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          VENTAS / ORDENES
                        </span>
                      </NavLink>
                    </li>
                  )}

                  {employee.inventario !== false &&
                  employee.inventario !== undefined ? (
                    <li
                      className={
                        ruta === "/inventario"
                          ? "nav-link activateLink"
                          : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/inventario">
                        <i className="bx bx-book-bookmark icon"></i>
                        <span
                          className={
                            ruta === "/inventario"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          INVENTARIO
                        </span>
                      </NavLink>
                    </li>
                  ) : (
                    <></>
                  )}

                  {employee.promociones !== false &&
                  employee.promociones !== undefined ? (
                    <li
                      className={
                        ruta === "/Promociones"
                          ? "nav-link activateLink"
                          : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/Promociones">
                        <i className="bx bxs-shapes icon"></i>
                        <span
                          className={
                            ruta === "/Promociones"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          PROMOCIONES
                        </span>
                      </NavLink>
                    </li>
                  ) : (
                    <></>
                  )}

                  {employee.caltruck && (
                    <li
                      className={
                        ruta === "/calificaciones"
                          ? "nav-link activateLink"
                          : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/calificaciones">
                        <i className="bx bx-star icon"></i>
                        <span
                          className={
                            ruta === "/calificaciones"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          CALIF. DE TRUCK
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {employee.calpedidos && (
                    <li
                      className={
                        ruta === "/calificacionesPedidos"
                          ? "nav-link activateLink"
                          : "navlink"
                      }
                    >
                      <NavLink exact="true" to="/calificacionesPedidos">
                        <i className="bx bx-star icon"></i>
                        <span
                          className={
                            ruta === "/calificacionesPedidos"
                              ? "text nav-text changeColor"
                              : "text nav-text"
                          }
                          style={{ fontSize: 12 }}
                        >
                          CALIF. PEDIDOS
                        </span>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </>
            ) : (
              <></>
            )}
          </div>

          {/* <div className="bottom-content">
            <li className="">
              <a>
                <i className="bx bx-log-out icon"></i>
                {!isPending && (
                  <span
                    className="text nav-text"
                    onClick={logout}
                    style={{ fontSize: 12 }}
                  >
                    CERRAR SESIÓN
                  </span>
                )}
                {isPending && (
                  <span className="text nav-text">Saliendo...</span>
                )}
              </a>
            </li>
          </div> */}
        </div>
      </nav>
    </>
  );
}
